(function () {
  'use strict';
  if (window.location.pathname !== '/pages/cells-are-running-out-of-energy') return;
  var forms = { XTCPiH: true, WTx5TD: true };
  window.addEventListener('klaviyoForms', function (event) {
    var cmp = window.Consentmo;
    if (!cmp || typeof cmp.marketingAllowed !== 'function' || cmp.marketingAllowed() !== true) return;
    var detail = event.detail || {};
    if (!forms[detail.formId] || (detail.type !== 'submit' && detail.type !== 'stepSubmit')) return;
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    var variant = '';
    try {
      if (sessionStorage.getItem('rbs_meta_ns_' + detail.formId)) return;
      variant = sessionStorage.getItem('ab_test_variant') || '';
      sessionStorage.setItem('rbs_meta_ns_' + detail.formId, '1');
    } catch (error) {}
    analytics.publish('newsletter_signup', {
      form_id: detail.formId,
      form_name: detail.formId === 'WTx5TD' ? 'Cells Out of Energy lead magnet (long)' : 'Cells Out of Energy lead magnet (short)',
      page_path: window.location.pathname.replace(/\/$/, '') || '/',
      ab_variant: variant
    });
  });
})();
